import { icon } from "../icons.js";
import { esc } from "./html.js";

// Экран статуса брони (T6): виджет открыт с query-параметром возврата с оплаты
// (?okb_order=<orderToken> и вероятные имена Шелтера — см. lib/checkout.js).
// Ответ getOrder не документирован, поэтому показываем то, что распознали, и деградируем достойно.
export function renderStatus(state) {
  const st = state.status;
  let body;
  if (st.loading) {
    body = `<h3>Проверяем бронирование…</h3><p class="okb-cohint">Запрашиваем статус у системы бронирования.</p>`;
  } else if (st.error) {
    body = `<h3>Не удалось проверить статус</h3><p class="okb-cohint">${esc(st.error)}</p>
      <p class="okb-cohint">Если вы только что оплатили бронь — не волнуйтесь: подтверждение придёт на e-mail. Можно просто позвонить нам.</p>`;
  } else {
    const d = st.data ?? {};
    const title =
      d.bookingCode != null ? `Бронирование №${esc(String(d.bookingCode))}` : "Ваше бронирование";
    let line;
    // демо-бронь (d.demo) для гостя не отличается от настоящей — надписей «тест» нет (T19)
    if (d.orderCanceled === true) line = "Бронь аннулирована.";
    else if (d.isPaid === true) line = "Оплата получена — бронь подтверждена. Ждём вас!";
    else if (d.isPaid === false) line = "Бронь создана и ожидает оплаты.";
    else line = "Бронь найдена. Подтверждение и детали придут на указанный e-mail.";
    const ok = d.isPaid === true && d.orderCanceled !== true;
    body = `<h3>${ok ? icon("check") : ""} ${title}</h3><p class="okb-cohint">${line}</p>`;
  }
  return `
  <div class="okb-cocard okb-costatus">
    ${body}
    <button type="button" class="okb-colink" data-okb="status-back">← Вернуться к поиску</button>
  </div>`;
}
